import { WSActionType } from '../action/WebSocketAction';

const defaultState = {
  error: false,
  disconnected: false,
  reconnecting: false,
  reconnected: false,
  connected: false,
  connecting: false,
};

export default function PhotoReducer(state = defaultState, action) {
  switch (action.type) {
    case WSActionType.ERROR:
      return Object.assign({}, defaultState, {
        error: true,
      });
    case WSActionType.CONNECTING:
      return Object.assign({}, defaultState, {
        connecting: true,
      });
    case WSActionType.CONNECTED:
      return Object.assign({}, defaultState, {
        connected: true,
      });
    case WSActionType.DISCONNECTED:
      return Object.assign({}, defaultState, {
        disconnected: true,
      });
    case WSActionType.RECONNECTING:
      return Object.assign({}, defaultState, {
        reconnecting: true,
      });
    case WSActionType.RECONNECTED:
      return Object.assign({}, defaultState, {
        reconnected: true,
      });
    default:
      break;
  }

  return state;
}
